import Accounts from "src/models/accounts";
import Skus from "src/models/skus";
import "can/construct/";


export default can.Construct.extend({
    init: function() {
        "use strict";
        Vistracks[ "subAccountsCollection" ] = [];
        Vistracks[ "mainAccountSkuCollection" ] = [];
        Vistracks[ "skusCollection" ] = [];

        can.when(
            Skus.findAll({}),
            Accounts.findChildAccounts({})
        )
        .then(
            ( skus, accounts ) => {
                Vistracks.skusCollection = skus;

                // Get sub-accounts including its skus
                if ( accounts[ 0 ].hasOwnProperty( "subAccounts" ) ) {
                    let splicedAccounts = accounts[ 0 ].serialize().subAccounts;
                        splicedAccounts.splice( 0, 0, {
                            id: accounts[ 0 ].id,
                            name: accounts[ 0 ].name,
                        });

                    let accountIds = _.map( splicedAccounts, account => {
                        return account.id;
                    }).join( "+" );

                    Accounts.findCertainAccounts({
                        accountIds: accountIds
                    })
                    .done( responseData => {
                        Vistracks.subAccountsCollection = _.map( responseData, account => {
                            return {
                                id: account.id,
                                name: account.name,
                                skuIds: account.skuIds
                            };
                        });

                        // Fix: Issue on `accounts` API does not return a record of the top
                        // level account
                        Vistracks.subAccountsCollection.push({
                            id: accounts[ 0 ].id,
                            name: accounts[ 0 ].name,
                            skuIds: _.map( Vistracks.skusCollection, item => {
                                return item.id;
                            })
                        });
                    });
                } else {
                    Vistracks.subAccountsCollection.push({
                        id: accounts[ 0 ].id,
                        name: accounts[ 0 ].name,
                        skuIds: _.map( Vistracks.skusCollection, item => {
                            return item.id;
                        })
                    });
                }

                _( skus ).forEach( sku => {
                    let skuNumber;
                    if ( !isNaN( sku.skuNumber ) ) {
                        skuNumber = _.parseInt( sku.skuNumber );
                        Vistracks.mainAccountSkuCollection.push( skuNumber );
                    }
                });
            },

            responseError => Vistracks.HelperUtils.jqXHR.errorHandler( responseError )
        );
    }
});
